/* eslint-disable no-use-before-define */
import React from 'react'
import { $, ajax, parseJson, Status, getState } from '../twd'

const last = getState('saved-searches.last', {ts:0})

export default ({refresh=true}) => {

    const [status, setStatus] = React.useState(refresh ? Status.LOADING : Status.LOADED)
    const [rows, setRows] = React.useState(refresh ? [] : last.value.rows)

    React.useEffect(() => {(async () => {
        if (status!==Status.LOADING) return

        try {
            let {data} = ajax({
                url: '/esb/portfolio/savedQuerySearchByCurrentUser',
                method: 'GET'
            })

            let rs = ((await data) || [])
                .map(a => {
                    a.modified = new Date(a.modified)
                    a.queryText = parseJson(a.formText)
                    a.searchParams = (a.queryText || {}).metadata || a.queryText || {}
                    return a
                })
                .filter(a => {
                    return a.searchParams.searchType === 'offers'
                })
                .sort((a,b) => b.modified.valueOf() -a.modified.valueOf())

            // state.savedSearches = rs
            setRows(rs)

            setStatus(Status.LOADED)
        } catch(e) {
            setStatus(Status.FAILED_TO_LOAD)
        }

    })()}, [status])

    React.useEffect(() => {
        return () => { $('.tooltip').remove() }
    })

    return { status, rows }

}



// WEBPACK FOOTER //
// ./src/saved-searches/use-saved-searches.js